import { render, staticRenderFns } from "./Entrust.vue?vue&type=template&id=568c7615&scoped=true"
import script from "./Entrust.vue?vue&type=script&lang=js"
export * from "./Entrust.vue?vue&type=script&lang=js"
import style0 from "./Entrust.vue?vue&type=style&index=0&id=568c7615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c7615",
  null
  
)

export default component.exports